/* eslint-disable react/no-unused-prop-types */
import React from "react";
import SaveWrapper from "components/Save";
import TourRequest from "components/Save/Tour";
import { analyticsEvents, track } from "util/analytics";
import { trackInquireClick, trackSaveListing } from "util/ga4";
import styles from "./styles.module.scss";

type Props = {
  selectedListingId?: string | number | null;
  buildingId: string | number;
  displayAddress: string;
  areaExternalIds: string[];
  marketOfInterest?: string;
  cityOfInterest?: string;
  currentUser?: {
    id: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
  };
};

const CTAButtons = ({
  selectedListingId,
  buildingId,
  displayAddress,
  marketOfInterest,
  cityOfInterest,
  areaExternalIds = [],
}: Props) => {
  const listingOrBuilding = selectedListingId ? "Listing" : "Building";

  return (
    <div className={styles.buttons}>
      <h3 className={`subheader ${styles.hiddenMobile}`}>
        Interested in this {listingOrBuilding.toLocaleLowerCase()}?
      </h3>
      <SaveWrapper
        inquiribleId={(selectedListingId || buildingId).toString()}
        signUpType={listingOrBuilding}
        source="Inquire"
        type={listingOrBuilding}
        marketOfInterest={marketOfInterest}
        cityOfInterest={cityOfInterest}
        areaExternalIds={areaExternalIds}
      >
        {(save, isSaved, loading) => (
          <button
            type="button"
            data-qa="building-page-inquiry-button"
            className={`btn-primary ${styles.button}`}
            disabled={isSaved || loading}
            onClick={(e) => {
              track(analyticsEvents.clicked, {
                category: `${listingOrBuilding} Page CTAs`,
                label: "Inquire",
              });
              trackInquireClick({
                listingId: selectedListingId || buildingId,
                buildingName: displayAddress,
                city: cityOfInterest || "",
              });
              save(e);
            }}
          >
            {isSaved ? (
              <>
                <span className="icon-check" />
                Inquiry Received
              </>
            ) : (
              <>Inquire about {listingOrBuilding}</>
            )}
          </button>
        )}
      </SaveWrapper>

      <TourRequest
        id={(selectedListingId || buildingId).toString()}
        signUpType={listingOrBuilding}
        source="Tour Request"
        type={listingOrBuilding}
        btnClassName={`${styles.button} ${styles.hiddenMobile}`}
        title={displayAddress}
        marketOfInterest={marketOfInterest}
        cityOfInterest={cityOfInterest}
        areaExternalIds={areaExternalIds}
        data-qa="building-page-request-tour-button"
      />

      <SaveWrapper
        inquiribleId={(selectedListingId || buildingId).toString()}
        signUpType={listingOrBuilding}
        source="Save"
        type={listingOrBuilding}
        marketOfInterest={marketOfInterest}
        cityOfInterest={cityOfInterest}
        areaExternalIds={areaExternalIds}
      >
        {(save, isSaved, loading) => (
          <button
            type="button"
            data-qa="building-page-inquire-building-button"
            className={`btn-outline ${styles.button} ${styles.hiddenMobile}`}
            disabled={isSaved || loading}
            onClick={(e) => {
              track(analyticsEvents.clicked, {
                category: `${listingOrBuilding} Page CTAs`,
                label: "Save",
              });
              trackSaveListing({
                listingId: selectedListingId || buildingId,
                buildingName: displayAddress,
                city: cityOfInterest || "",
              });
              save(e);
            }}
          >
            {isSaved ? (
              <>
                <span className="icon-check" />
                Inquiry Received
              </>
            ) : (
              <>
                {listingOrBuilding === "Listing" && (
                  <i className="icon icon-bookmark" />
                )}{" "}
                Save {listingOrBuilding}
              </>
            )}
          </button>
        )}
      </SaveWrapper>
    </div>
  );
};

export default CTAButtons;
